function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceWorkTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,7.57a8.45,8.45,0,1,1-8.41,8.49V16A8.47,8.47,0,0,1,16,7.57M16,6A10,10,0,1,0,26,16v0A10,10,0,0,0,16,6h0Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.23,
    y: 9.07,
    width: 1.54,
    height: 8.45,
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.46,
    y: 15.21,
    width: 8.45,
    height: 1.54,
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceWorkTime);
export default __webpack_public_path__ + "static/media/presence-work_time.a36ff51a.svg";
export { ForwardRef as ReactComponent };